import { useMutation } from "react-query";
import { showErrorToast, showSuccessToast } from "~/components/Toast";
import i18n from "~/i18n";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useBatchCreateVirtualUsers = () => {
  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/users/batch-create-virtual-user`,
        method: "POST",
        body: data,
      }),
    onSuccess: (response = []) => {
      showSuccessToast(
        i18n.t("{{count}} users added", {
          count: response.length,
        })
      );
    },
    onError: () => {
      showErrorToast(i18n.t("Unable to add users."));
    },
  });
};
